import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Summary from "./Summary";
import AddNewsCategory from "./New";
import NewsCategoryList from "./List";
import EditNewsCategory from "./Edit";
import NewsCategoryDetails from "./Details";

function Index() {
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path="list"
          element={
            <>
              <NewsCategoryList />
            </>
          }
        />
        <Route
          path="new"
          element={
            <>
              <AddNewsCategory />
            </>
          }
        />
        <Route
          path="edit/:primary_id"
          element={
            <>
              <EditNewsCategory />
            </>
          }
        />
        <Route
          path="details/:primary_id"
          element={
            <>
              <NewsCategoryDetails />
            </>
          }
        />

        <Route index element={<Navigate to="/news_category/list" />} />
      </Route>
    </Routes>
  );
}

export default Index;
